import GDGOVParameterExceptionModal from './GDGOV_parameter_exception-modal.vue'
export default GDGOVParameterExceptionModal
